import { render } from "./WhatsDay.vue?vue&type=template&id=58709ac6"
import script from "./WhatsDay.vue?vue&type=script&lang=js"
export * from "./WhatsDay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__